module.exports = __webpack_public_path__ + "static/media/invite-now.685a97a9.png";